class Deferred {
  /**
   * Creates a new deferred promise.
   */
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}
async function forEachWithConcurrency(items, concurrency, callback) {
  if (items.length === 0) {
    return;
  }
  let index = 0;
  async function consumeItems() {
    while (index < items.length) {
      const item = items[index];
      index += 1;
      await callback(item);
    }
  }
  await Promise.all(Array.from({ length: Math.min(concurrency, items.length) }, async () => await consumeItems()));
}
const devToolsAwareTimeout = (callback, timeout) => {
  const interval = timeout > longTimeoutThreshold ? longTimeoutInterval : timeout / shortTimeoutIntervals;
  let elapsed = 0;
  const reference = setInterval(() => {
    elapsed += interval;
    if (elapsed >= timeout) {
      clearInterval(reference);
      callback();
    }
  }, interval);
  return reference;
};
const longTimeoutThreshold = 4e3;
const longTimeoutInterval = 2e3;
const shortTimeoutIntervals = 4;
export {
  Deferred,
  devToolsAwareTimeout,
  forEachWithConcurrency
};
